import {Dimmer, Loader} from 'semantic-ui-react';

export default function LogoutCallback() {
  return (
    <Dimmer active>
      <Loader>Logging out. This can take a few seconds</Loader>
    </Dimmer>
  );
}
